import styled from 'styled-components';

export default styled.div`
  width: calc(40vw + 180px);
  max-width: calc(450px + 180px);
  height: 420px;
`;
